import { useEffect, useLayoutEffect, useRef, useState } from "react";

// The workout-level note in the FINISHED Review: an open field that invites a
// short reflection before saving. No "add" step, no edit action and no button
// of its own: it commits when focus leaves it, exactly like every other note,
// and Save Workout stays the one final action.
// `onCommit` receives the new note, or null when it was cleared; it is called
// only when the text differs from the committed value.
export default function ReviewReflection({ id, value, maxLength, disabled = false, onCommit }) {
  const committed = value || "";
  const [draft, setDraft] = useState(committed);
  const fieldRef = useRef(null);

  // Resync the draft only when the committed value changes, so a background
  // sync reload never clobbers text being typed.
  useEffect(() => {
    setDraft(committed);
  }, [committed]);

  // As tall as its text, between the CSS minimum and maximum. scrollHeight
  // leaves the borders out; they are added back.
  useLayoutEffect(() => {
    const field = fieldRef.current;
    if (!field) return;
    field.style.height = "auto";
    field.style.height = `${field.scrollHeight + field.offsetHeight - field.clientHeight}px`;
  }, [draft]);

  function commit() {
    if (draft !== committed) onCommit?.(draft || null);
  }

  return (
    <div className="lz-workout-review-reflection">
      <label htmlFor={id}>Your thoughts about this workout</label>
      <textarea
        ref={fieldRef}
        id={id}
        rows={2}
        maxLength={maxLength}
        value={draft}
        disabled={disabled}
        placeholder="How did it feel? Anything to remember for next time?"
        onChange={(event) => setDraft(event.target.value)}
        onBlur={commit}
      />
    </div>
  );
}
